import classes from './AppHeader.module.css';
import { useContext, useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import NavigationButton from './NavigationButton';
import '../../css_styles/button_styles.css'
import SelectWorkspace from '../../user_login/SelectWorkspace';
import { SERVER_URL } from '../../config_server_url';
import UserSessionContext from '../../user_session/context_user_session';
import DisplayException from '../../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { useNavigate } from 'react-router-dom';

function NavigationBar(){
    const [selection, setSelection] = useState([false, true, false]);
    const { logout, user} = useAuth0();
    const [selectWorkspace, setSelectWorkspace] = useState(false);
    const [availableWorkspaces, setAvailableWorkspaces] = useState([]);
    const usr_session_ctx = useContext(UserSessionContext);
    const [isLoading, setIsLoading] = useState(false);
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    const navigate = useNavigate();
    const [navBarElement, setNavBarElement] = useState(null);


    function updateSelectionHandler(event) {
        let id_name = event.target.id
        const dev_sel = [false, false, false ];
        if (id_name === 'nav_bar_create_new_project') { dev_sel[0] = true; }
        if (id_name === 'nav_bar_current_project') { dev_sel[1] = true; }
        if (id_name === 'nav_bar_all_projects') { dev_sel[2] = true; }
        setSelection ( dev_sel );
    }

    useEffect(()=>{
        load_available_workspaces();
    },[])

    function load_available_workspaces(){
        setIsLoading(true);
        fetch(`${SERVER_URL}/user_session/load_available_workspaces/`, {
            method: "GET",
            headers:{'auth0_user': user.sub }
        })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((available_workspaces) => {
            setAvailableWorkspaces(available_workspaces.data);
            setIsLoading(false); 
        })
        .catch((err) => {
            setException(true);
            setIsLoading(false);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }


    function load_user_session(uuid_tenant){
        setIsLoading(true);
        fetch(`${SERVER_URL}/user_session/initialize/`, {
            method: "GET",
            headers:{'auth0_user': user.sub,
                     'uuid_tenant': uuid_tenant
             }
        })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((user_session) => {
            if(user_session.msg !== '') {
                setException(true);
                setExceptionMessage(`ServerError: err_msg=${user_session.msg}`);
            }
            else{
                usr_session_ctx.uuid_tenant = user_session.data.uuid_tenant;
                usr_session_ctx.session_info = user_session.data.session_info;
                setIsLoading(false); 
            }
        })
        .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
    }


    function handleSelectWorkspace(){
        load_available_workspaces();
        setSelectWorkspace(true);
    }

    function handleSelect(event){
        const uuid_tenant = event.target.id;
        load_user_session(uuid_tenant)
        setSelectWorkspace(false);
    }


    useEffect(() => {
        const interval = setInterval(() => {
          const element = document.getElementById('nav_bar_current_project');
          if (element) {
            setNavBarElement(element);
            clearInterval(interval); // Stop checking once the element is found
          }
        }, 100); // Check every 100ms
    
        return () => clearInterval(interval); // Cleanup on component unmount
      }, [usr_session_ctx.uuid_tenant]);


    useEffect(()=>{
        if(navBarElement){
            navigate('/');
            document.getElementById('nav_bar_current_project').click();
        }
    },[navBarElement]);


    if(Exception){
        return (<>
                <DisplayException>
                    {ExceptionMessage}
                </DisplayException>  
            </>)
        }
    else if(isLoading){
        return (
            <>
                {/* <AppHeader /> */}
                <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                    <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                </div>
            </>);
    }
    else if (selectWorkspace){
        return (<SelectWorkspace workspaces={availableWorkspaces}
                                 select={handleSelect} />);
    }
    else {
        return (
        <>
            <div className={classes.navbar} style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                    <NavigationButton id='nav_bar_create_new_project' href={'/create_new_project'} is_selected={selection[0]} title='Create New Project' onUpdateSelection = {updateSelectionHandler} />
                    <NavigationButton id='nav_bar_current_project' href={'/'} is_selected={selection[1]} title='Current Project' onUpdateSelection = {updateSelectionHandler} />
                    <NavigationButton id='nav_bar_all_projects' href={'/all_projects'} is_selected={selection[2]} title='All Projects' onUpdateSelection = {updateSelectionHandler} />
                    {availableWorkspaces.length > 1 && (<div style={{marginLeft: '10px', marginRight: '-20px'}}> 
                        <button className='actionButtonSmall' 
                                onClick={handleSelectWorkspace}> Workspaces </button>
                    </div>)}
                    <div style={{marginLeft: '10px', marginRight: '10px'}}> 
                        <button className='actionButtonSmall' 
                            onClick={ () => logout({ logoutParams: { returnTo: window.location.origin }}) }>
                            Sign Out 
                        </button>
                    </div>
            </div>
        </>
        );
        }
}

export default NavigationBar;